module.exports = __webpack_public_path__ + "static/media/site-inspector.9a5f5638.svg";